import { useOidc } from "@axa-fr/react-oidc";
import { useCallback } from "react";

// --- Page Tracking ---
type PageDetails = {
    path: string;
    tabPosition: any;
    tabName: String;
};

var previousPageDetails: PageDetails;

export const useHandleUnauthorized = () => {
    const { logout } = useOidc();

    const handleUnauthorized = useCallback((res: any) => {
        if (
            (res?.status === 400 || res?.status === 401) &&
            res?.message === "Request failed with status code 401"
        ) {
            console.error('Unauthorized access - logging out');
            logout('/'); // Call logout function
        }
    }, [logout]);

    return { handleUnauthorized };
};

export function getPreviousPageDetails() {
    return previousPageDetails;
}